/* ============
 * Postal Module Mutations
 * ============
 */

import {
  FETCH_POSTALS,
} from './../../mutation-types';

export default {
  [FETCH_POSTALS](state, { postals }) {
    state.all = postals;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/postal/mutations.js